'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={['fixed top-0 left-0 right-0 z-50 transition-all duration-300', scrolled ? 'bg-background/95 backdrop-blur-md border-b border-border shadow-sm' : 'bg-transparent']?.join(' ')}>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AppLogo size={32} />
          <span className="font-black text-lg text-foreground tracking-tight">InstaExtract</span>
        </div>

        <div className="hidden md:flex items-center gap-8">
          <a href="#how-it-works" className="text-sm font-semibold text-foreground/70 hover:text-foreground transition-colors">How It Works</a>
          <a href="#pricing" className="text-sm font-semibold text-foreground/70 hover:text-foreground transition-colors">Pricing</a>
          <a href="#faq" className="text-sm font-semibold text-foreground/70 hover:text-foreground transition-colors">FAQ</a>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link href="/sign-up-login-screen" className="text-sm font-bold text-foreground px-4 py-2 hover:opacity-70 transition-opacity">
            Log In
          </Link>
          <Link href="/sign-up-login-screen" className="btn-primary text-sm px-5 py-2.5">
            Get Started Free
          </Link>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden p-2 rounded-md hover:bg-muted transition-colors"
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-background border-b border-border px-6 py-4 space-y-3 fade-in">
          <a href="#how-it-works" onClick={() => setMenuOpen(false)} className="block text-sm font-semibold text-foreground/70 hover:text-foreground py-1">How It Works</a>
          <a href="#pricing" onClick={() => setMenuOpen(false)} className="block text-sm font-semibold text-foreground/70 hover:text-foreground py-1">Pricing</a>
          <a href="#faq" onClick={() => setMenuOpen(false)} className="block text-sm font-semibold text-foreground/70 hover:text-foreground py-1">FAQ</a>
          <div className="pt-2 flex flex-col gap-2">
            <Link href="/sign-up-login-screen" className="text-sm font-bold text-center py-2">Log In</Link>
            <Link href="/sign-up-login-screen" className="btn-primary text-sm text-center">Get Started Free</Link>
          </div>
        </div>
      )}
    </nav>
  );
}